import { TREE_SET_TEMPDATA } from '~/frontend/src/constants';

type SetTreeTempDataAction = {
    type: typeof TREE_SET_TEMPDATA;
    panelKey: string;
    data: any;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {any} data
 *
 * @return {SetTreeTempDataAction}
 */
export default function setTempData( panelKey: string, data: any ): SetTreeTempDataAction {
    return {
        type     : TREE_SET_TEMPDATA,
        panelKey,
        data
    };
}
